import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;
let assignedLocations = JSON.parse(localStorage.getItem("assingedL"));
const locations = assignedLocations?.map((e) => {
  return '"' + e.value + '"';
});
/**
 *
 * @param {*} params
 * @returns {Promise<FetchBrokerOwnersResponse>}
 */
export function requestLeadList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/lead/getleadByfilterNew`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/lead/getleadByfilterNew?${params}`,);
  }
}

export function requestLeadListNew(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/lead/getleadByfilterNew`, {
      params: { limit: 999999999,pgno:1 },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/lead/getleadByfilterNew?${params}`,{
    params: { limit: 999999999,pgno:1 }
    });
  }
}

export function requestLeadListCRUD(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/lead`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/lead?${params}&location[in]=[${locations}]`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
/**
 *
 * @param {LeadForm} data
 * @returns
 */
export function requestCreateLead(data) {
  return fetch.post(`${BASE_URL}/api/app/lead`, data);
}

/**
 *
 * @param {LeadForm} data
 * @returns
 */
export function requestUpdateLead(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/lead/${data._id}`, body);
}

/**
 *
 * @param {LeadStageChange} data + _id
 * @returns
 */
export function requestLeadStageChange(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.patch(`${BASE_URL}/api/app/lead/change-stage/${data._id}`, body);
}

/**
 *
 * @param {AddLeadNote} data
 * @returns
 */
export function requestAddNoteToLead(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.patch(`${BASE_URL}/api/app/lead/add-note/${data._id}`, body);
}

/**
 *
 * @returns
 */
export function requestDeleteLeadNote(data) {
  return fetch.delete(
    `${BASE_URL}/api/app/lead/delete-note/${data.leadId}/${data.noteId}`
  );
}
export function requestKPISData(params) {
  if (params !== undefined) {
    return fetch.get(`${BASE_URL}/api/app/lead/getKpi?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER  },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/lead/getKpi`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
